import { Separator } from "../../../../../../components/ui/Separator";
import { ProfilerProduct } from "../../../../types/ProfilerProduct";
import { BeautyProfilerBeautyRitual } from "./BeautyProfilerBeautyRitual";
import { BeautyProfilerFavoriteFragrance } from "./BeautyProfilerFavoriteFragrance";
import { BeautyProfilerSecondaryFragrances } from "./BeautyProfilerSecondaryFragrances";

type BeautyProfilerDetailedResultsProps = {
  topFetiche: ProfilerProduct | null;
  topSecondaryFragrances: {
    secondFetiche: ProfilerProduct | null;
    topLoubiworld: ProfilerProduct | null;
  };
  topOtherProduct: {
    topGlamliner: ProfilerProduct | null;
    topOtherProducts: ProfilerProduct[];
  };
};

export const BeautyProfilerDetailedResults = ({
  topFetiche,
  topSecondaryFragrances,
  topOtherProduct,
}: BeautyProfilerDetailedResultsProps) => {
  return (
    <div className="h-full bg-[#FBF9F7] py-8 px-6 overflow-y-scroll relative flex flex-col items-center">
      <div className="flex flex-col gap-6 max-w-[1000px] w-full">
        <BeautyProfilerFavoriteFragrance topFetiche={topFetiche} />
        <Separator className="bg-[#F5EEEB]" />
        <BeautyProfilerSecondaryFragrances
          topSecondaryFragrances={topSecondaryFragrances}
        />
        <Separator className="bg-[#F5EEEB]" />
        <BeautyProfilerBeautyRitual topOtherProduct={topOtherProduct} />
      </div>
    </div>
  );
};
